<template>
    <label class="form__checkbox" :class="{error: error}">
        <input
            :checked="checked"
            type="checkbox"
            @change="$emit('eventChange', $event.target.checked)"
        >
        <pre></pre>
        {{ placeholder }}
    </label>
</template>

<script>
export default {
    name: 'Checkbox',
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        checked: {
            type: Boolean,
            default: false
        },
        error: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss">
    .form__checkbox {
        display: flex;
        align-items: center;
        color: $black;
        font-size: 16px;
        margin: -6px 0 43px 0;

        input {
            display: none;

            &:checked {

                ~ pre::before {
                    opacity: 1;
                }
            }
        }

        pre {
            position: relative;
            flex-shrink: 0;
            width: 22px;
            height: 22px;
            margin: 0 14px 0 0;
            background: $pink;
            box-sizing: border-box;
            border-radius: 5px;
            transition: 150ms ease-in-out;

            &::before {
                content: '';
                position: absolute;
                top: 7px;
                left: calc(50% - 5px);
                width: 11px;
                height: 8.25px;
                background: url('../../assets/check.svg') center no-repeat;
                transition: 75ms ease-in-out;
                opacity: 0;
            }
        }

        &.error {

            pre {
                border-color: $red;
            }
        }
    }
</style>